import {ReportSection} from "../../model.product/ReportSection";
import {FacilityReportSections2} from "./FacilityReportSections2";


export class FacilityReportSections4 {

  public static readonly VALUE: ReportSection[] = FacilityReportSections2.VALUE;

}
